export const WORDS = [
  'さいたま',
  'おかやま',
  'まえばし',
  'ふくしま',
  'まつやま',
  'ひろしま',
  'とくしま',
  'もりおか',
  'やまぐち',
  'みやざき',
  'よこはま',
  'ふくおか',
  'しずおか',
  'おおさか',
  'かごしま',
  'とっとり',
  'くまもと',
  'あおもり',
  'せんだい',
  'ながさき',
  'にいがた',
  'わかやま',
  'やまがた',
  'たかまつ',
  'きょうと',
  'かなざわ',
  'おおいた',
  'さっぽろ',
]
